export default {
    monitor: {name: "Monitor"},
    keyboard: {name: "Klawiatura"},
    mouse: {name: "Mysz"},
    webcam: {name: "Kamerka internetowa"},
    headset: {name: "Zestaw słuchawkowy"},
    dockingStation: {name: "Stacja dokująca"},
}